import { RunSchema } from '@/types/schema';

export function getRunTypeName(
  run: Pick<RunSchema, 'run_type' | 'name'> | undefined | null
) {
  let content = '\u2003\u2003\u2003';
  if (run?.run_type) {
    content = run.run_type;
  }

  if (content === 'llm') {
    content = 'LLM';
  }

  if (
    run?.run_type === 'chain' &&
    (run.name === 'RunnableSequence' || run.name === 'RunnableParallel')
  ) {
    content = run.name === 'RunnableSequence' ? 'Sequence' : 'Parallel';
  }

  return content.slice(0, 1).toUpperCase() + content.slice(1);
}
